export const queryKey = {
  goodsDetail: (goodsId: number, fixedCouponSno?: number) => [
    'goodsDetail',
    goodsId,
    fixedCouponSno,
  ],
  goodsBasic: (goodsId: number, fixedCouponSno?: number) => [
    'goodsBasic',
    goodsId,
    fixedCouponSno,
  ],
  goodsDiscount: (goodsId: number, fixedCouponSno?: number) => [
    'goodsDiscount',
    goodsId,
    fixedCouponSno,
  ],
  goodsCouponList: (goodsId: number, fixedCouponSno?: number) => [
    'goodsCouponList',
    goodsId,
    fixedCouponSno,
  ],
  goodsCoupon: (goodsId: number, fixedCouponSno?: number) => [
    'goodsCoupon',
    goodsId,
    fixedCouponSno,
  ],
  goodsCodi: (goodsId: number) => ['goodsCodi', goodsId],
  goodsMidRelatedRecommend: (goodsId: number) => [
    'goodsMidRelatedRecommend',
    goodsId,
  ],
  goodsReviewSummary: (goodsId: number) => ['goodsReviewSummary', goodsId],
  goodsReadReviewsSummary: (goodsId: number) => [
    'goodsReadReviewsSummary',
    goodsId,
  ],
  goodsReviewsPhotoFeeds: (goodsId: number) => [
    'goodsReviewsPhotoFeeds',
    goodsId,
  ],
  goodsReviews: (goodsId: number) => ['goodsReviews', goodsId],
  similarGoods: (goodsId: number) => ['similarGoods', goodsId],
  aiStudioBanner: (goodsId: number, mode: string) => [
    'aiStudioBanner',
    goodsId,
    mode,
  ],
  relatedGoods: (goodsId: number) => ['relatedGoods', goodsId],
  promotionsComponents: (goodsId: number, screen: string) => [
    'promotionsComponents',
    goodsId,
    screen,
  ],
  goodsAtomicComponents: (goodsId: number) => [
    'goodsAtomicComponents',
    goodsId,
  ],
  goodsRelatedOutfit: (goodsId: number) => ['goodsRelatedOutfit', goodsId],
  goodsRepresentativeImagesRedirectPath: (goodsId: number) => [
    'RepresentativeImagesRedirectPath',
    goodsId,
  ],
  goodsAwards: (goodsId: number) => ['goodsAwards', goodsId],
  goodsLikeRecommend: (goodsId: number) => ['goodsLikeRecommend', goodsId],
  goodsCartRecommend: (goodsId: number) => ['goodsCartRecommend', goodsId],
  goodsOptions: (
    goodsId: number,
    params?: { depth?: number; selected_option_sno?: number },
  ) => ['goodsOptions', goodsId, params],
  goodsOptionsBrief: (goodsId: number) => ['goodsOptionsBrief', goodsId],
  goodsOptionsPricing: (goodsId: number, body?: object) =>
    body
      ? ['goodsOptionsPricing', goodsId, body]
      : ['goodsOptionsPricing', goodsId],
  applyDiscounts: (goodsId: number, discountSnos: string[]) => [
    'applyDiscounts',
    goodsId,
    discountSnos,
  ],
  goodsReviewsMetadata: (goodsId: number) => ['goodsReviewsMetadata', goodsId],
  goodsReviewsAvailableInfo: (goodsId: number) => [
    'goodsReviewsAvailableInfo',
    goodsId,
  ],
  reviewCodiGoods: (reviewSno: number) => ['reviewCodiGoods', reviewSno],
  goodsPieces: (goodsId: number) => ['goodsPieces', goodsId],
  goodsLegalNotice: (goodsId: number) => ['goodsLegalNotice', goodsId],
  goodsPIPNInfo: (goodsId: number) => ['goodsPIPNInfo', goodsId],
  goodsSellerInfo: (goodsId: number) => ['goodsSellerInfo', goodsId],
  goodsModelInfo: (goodsId: number) => ['goodsModelInfo', goodsId],
  relatedLiveCampaign: (goodsId: number) => ['relatedLiveCampaign', goodsId],
  beautyRecommendedOption: (goodsId: number) => [
    'beautyRecommendedOption',
    goodsId,
  ],
  sizeReviewAnalysis: (goodsId: number) => ['sizeReviewAnalysis', goodsId],
  affiliateGoods: (goodsId: number) => ['affiliateGoods', goodsId],
  goodsList: (params: {
    type: string;
    goodsId: number;
    isDeliveryFilterOn: boolean;
    position?: string;
    from?: string;
    perPage?: number;
  }) => ['goodsList', params],
};
